import React from 'react';
import SettingsSection from './SettingsSection';
import { ExtractProps } from 'app/utils/types';
import { useI18n } from 'app/components/localization';
import { DeviceType } from 'app/containers/rtc/DeviceManagerContext';
import SoundCheck from 'app/components/DeviceSetup/SoundCheck';
import Selfie from 'app/components/rtc/Selfie';
import DeviceSettings from 'app/components/DeviceSetup/DeviceSettings';
import { useCss } from 'app/utils/css';
import { Position } from 'app/components/rtc/PositionedVideo';

interface IMediaSettingsSectionProps extends ExtractProps<typeof SettingsSection> {
  type: DeviceType;
}

const MediaSettingsSection = ({ type, title, preview }: IMediaSettingsSectionProps) => (
  <SettingsSection title={title} preview={preview}>
    <DeviceSettings type={type} />
  </SettingsSection>
);

const MediaSettings: React.FunctionComponent = () => {
  const { t } = useI18n();
  const css = useCss();
  return (
    <>
      <MediaSettingsSection
        type={DeviceType.Video}
        title={t('rtc.settings.camera')}
        preview={
          <div className={css('selfiePreview', { width: '150px', height: '150px' })}>
            <Selfie disableBackground position={Position.AbsoluteFullWidth} />
          </div>
        }
      />
      <MediaSettingsSection
        type={DeviceType.Audio}
        title={t('rtc.settings.microphone')}
        preview={<SoundCheck />}
      />
    </>
  );
};

export default MediaSettings;
